import { getCookieNew, getParmUrl, clearCookieNew,setCookie } from "@/public/utils";

const fill = ["201", "203", "205", "301"]; //修改信息--未提交
const audit = ["101", "202", "204", "206", "207", "302", "303", "304", "305"]; //审核中
const succeed = ["100"];
//洗数据
export function selectItem(data) {
  const items = data.map((item, index) => {
    if (fill.includes(item.review_status)) {
      return {
        ...item,
        business_name: item.business_name,
        label: item.business_name + "(未提交)",
        key: item.business_id,
      };
    } else if (audit.includes(item.review_status)) {
      return {
        ...item,
        business_name: item.business_name,
        label: item.business_name + "(审核中)",
        key: item.business_id,
      };
    } else {
      return { ...item, label: item.business_name, key: item.business_id };
    }
  });
  items.push({
    label: "申请入驻",
    key: "申请入驻",
    business_id: "",
  });
  return items;
}
//选择label
export function selectLable(data) {
  if (!data || data.length == 0) {
    return "";
  }
  return data.find(item=>item.po_subject_code == getCookieNew("po_subject_code"))?data.find(item=>item.po_subject_code == getCookieNew("po_subject_code")).label:'申请入驻';
}
//跳转
export function selectNavigat(status, sid,businessId) {
  setCookie("businessId", businessId||'sigo', 3);
  if (!status) {
    clearCookieNew("sid");
    clearCookieNew("supplier_code");
    // clearCookieNew("supplier_company_code");
    window.location.href =
      window.location.origin +
      "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection"
  }
  if (status === "101") {
    //还未填写信息，前往完善信息页面
    window.location.href =
      window.location.origin +
      "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection"
  }
  if (["201", "202", "203", "204", "205", "206", "207"].includes(status)) {
    //去基础信息填写页面
    window.location.href =
      window.location.origin +
      "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection"
  }
  if (["301", "302", "303", "304", "305"].includes(status)) {
    window.location.href =
      window.location.origin +
      "/main/suppliersettlement/compliancecertification/index?opration=perfection&&sid=" +
      sid;
  }
  if (status == "100") {
    window.location.href = "/";
  }
}



// WEBPACK FOOTER //
// ./src/layout/SelectItem.jsx